module.exports = __webpack_public_path__ + "img/zczg.19c4f445.svg";